import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/vatPlans', request)
}

export {get}
